export enum AvailablePlatforms {
  IOS = 'ios',
  ANDROID = 'android',
}

function collectPlatformData() {
  // 2022 way of detecting. Note: this userAgentData feature is available only in secure contexts (HTTPS)
  if (typeof navigator.userAgentData !== 'undefined' && navigator.userAgentData != null) {
    return navigator.userAgentData.platform
  }

  // Deprecated but still works for most of the browsers
  if (typeof navigator.platform !== 'undefined') {
    const userAgent = navigator.userAgent.toLowerCase()

    if (/android/.test(userAgent)) {
      // Android device’s navigator.platform is often set as 'linux', so let’s use userAgent for them
      return 'android'
    }
    if (/iphone|ipad|ipod/.test(userAgent)) {
      return 'iOS'
    }
    if (/win/.test(userAgent)) {
      return 'Windows'
    }
    if (/mac/.test(userAgent)) {
      return 'macOS'
    }
    if (/linux/.test(userAgent)) {
      return 'Linux'
    }
    return navigator.platform
  }

  return 'unknown'
}

const platform = collectPlatformData().toLowerCase()

export const isOSX = /mac/.test(platform) // Mac desktop
export const isIOS = ['ios'].indexOf(platform) >= 0
export const isApple = isOSX || isIOS // Apple device (desktop or iOS)
export const isWindows = /win/.test(platform) // Windows
export const isAndroid = /android/.test(platform) // Android
export const isLinux = /linux/.test(platform) // Linux
export const isMobile = isIOS || isAndroid

export const isApplePlatform = isApple || isOSX || isApple

export const isDesktop = isOSX || isWindows || isLinux

function getIOSMajorVersion(): number | null {
  console.log('logged user agent', navigator.userAgent)
  console.log('logged max touch points', navigator.maxTouchPoints)
  console.log('logged platform', navigator.platform)
  console.log('isIOS', isIOS)
  console.log('isOSX', isOSX)
  const userAgent = navigator.userAgent

  if (!isIOS && !isOSX) {
    return null
  }

  const iphoneUserAgentMatch = userAgent.match(/iPhone OS (\d+)_\d+/)
  const ipadUserAgentMatch = userAgent.match(/(?:iPad; CPU OS|Version) (\d+)_\d+/)

  console.log('logged iphoneUserAgentMatch', iphoneUserAgentMatch)
  console.log('logged ipadUserAgentMatch', ipadUserAgentMatch)

  // Check if the device has more than 2 touch points
  // to determine if it's an ipad
  const hasTouchPoints = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 ? true : false

  if (!hasTouchPoints && !iphoneUserAgentMatch && isIOS) {
    return null
  }

  const match = iphoneUserAgentMatch || ipadUserAgentMatch
  return match ? parseInt(match[1], 10) : null
}

export function isIOSMajorVersion(majorVersion: number): boolean {
  const iosMajorVersion = getIOSMajorVersion()
  return iosMajorVersion === majorVersion
}

export const isLandscape = (): boolean =>
  window.matchMedia('(orientation: landscape)').matches;

export const addOrientationListener = (callback: (isLandscape: boolean) => void): (() => void) => {
  const orientationQuery = window.matchMedia('(orientation: landscape)');

  const handleChange = (e: MediaQueryListEvent) => {
    callback(e.matches);
  };

  orientationQuery.addEventListener('change', handleChange);

  return () => {
    orientationQuery.removeEventListener('change', handleChange);
  };
};

console.log('IS IOS VERSION 17', isIOSMajorVersion(17)); // true
